<div class="review-preview-wrapper">
  <h2 class="preview-heading">{{ uiText('heading') }}</h2>
  <p class="preview-subheading">{{ uiText('subheading') }}</p>
  <div class="review-preview-container">
    <div class="review-header">
      <div class="review-avatar">
        {{ displayName.charAt(0) }}
      </div>
      <div class="review-header-info">
        <div class="review-title">{{ displayName }}</div>
        <div class="review-subtitle">{{ tripSubtitle }}</div>
      </div>
      <div class="review-rating" *ngIf="generalRating !== null">
        <app-survey-star-rating
          [initialStars]="generalRating"
          [readonly]="true"
          [color]="'#ffb400'"
        ></app-survey-star-rating>
        <div class="rating-text">{{ generalRating | number: '1.0-0' }} / 5</div>
      </div>
    </div>

    <div class="review-body">
      <p *ngIf="generalFeedback" class="general-feedback">{{ generalFeedback }}</p>
      <p *ngIf="!generalFeedback" class="general-feedback empty">{{ uiText('noComment') }}</p>

      <div
        class="general-extra-ratings"
        *ngIf="expanded() && (easeRating !== null || valueForMoneyRating !== null)"
      >
        <div class="extra-rating-item" *ngIf="easeRating !== null">
          <span class="extra-rating-label">{{ uiText('ease') }}</span>
          <app-survey-star-rating
            class="small-stars"
            [initialStars]="easeRating"
            [readonly]="true"
            [color]="'#ffb400'"
          ></app-survey-star-rating>
        </div>
        <div class="extra-rating-item" *ngIf="valueForMoneyRating !== null">
          <span class="extra-rating-label">{{ uiText('valueForMoney') }}</span>
          <app-survey-star-rating
            class="small-stars"
            [initialStars]="valueForMoneyRating"
            [readonly]="true"
            [color]="'#ffb400'"
          ></app-survey-star-rating>
        </div>
      </div>

      <!-- Extra sections revealed when expanded -->
      <div class="expanded-content" *ngIf="expanded()">
        <div class="phase-review-item" *ngFor="let phase of phaseReviews">
          <div class="phase-header">
            <span class="phase-name">{{ phase.name }}</span>
          </div>

          <div class="phase-ratings" *ngIf="phase.ratings.length > 0">
            <div class="phase-rating-row" *ngFor="let r of phase.ratings">
              <span class="rating-label" *ngIf="r.name">{{ r.name }}</span>
              <app-survey-star-rating
                class="x-small-stars"
                [initialStars]="r.rating"
                [readonly]="true"
                [color]="'#ffb400'"
              ></app-survey-star-rating>
            </div>
          </div>

          <div class="phase-comment" *ngIf="phase.comment">
            <span class="comment-text">{{ phase.comment }}</span>
          </div>
        </div>
      </div>
    </div>

    <button type="button" class="expand-button" (click)="toggleExpand()">
      {{ expanded() ? uiText('showLess') : uiText('showMore') }}
    </button>
  </div>
</div>
